import axios from 'axios';
import { EndPoints, getParams, Http, TypeParams } from '../utils';
import { ItemBasic, ItemInfo, ItemPatch } from '../../typescript/itemInfo';
import { Farming } from '../../typescript/farming';
import { FeatureCollection, MultiPolygon } from '../../typescript/MapShapes';
export const ItemServices = {
    //Detalle de item
    getItemDetail: (itemId: number): Promise<ItemInfo> =>
        Http.get(`${EndPoints.ItemUrls.RANCH}`, {
            params: getParams([{ key: TypeParams.ID, value: itemId }])
        }).then(response => response.data),

    //Enviar item
    addPolygonToItem: (config: ItemPatch): Promise<any> => 
        Http.patch(`${EndPoints.ItemUrls.RANCH}`, config).then(response => response.data),

    //Listado de items pre-cargados
    getPreloadedItemsByYear: (year: string): Promise<{
        list: ItemBasic[],
        polygons: MultiPolygon
    }> =>
        Http.get(`${EndPoints.ItemUrls.RANCH_LIST}`, {
            params: getParams([{ key: TypeParams.YEAR, value: year }])
        }).then(response => response.data),

    //Listado de Zafras
    getFarmingList: (): Promise<Farming[]> =>
        Http.get(`${EndPoints.ItemUrls.FARMING_LIST}`).then(response => response.data),

    //KML/KMZ to GeoJson
    getGeojsonFile: (formData: any): Promise<FeatureCollection> =>
        Http.post(`${EndPoints.ItemUrls.PROCESS_FILE}`, formData)
        .then(response => response.data),

    //Get area for polygon
    getPolygonArea: (config): Promise<FeatureCollection> =>
        Http.post(`${EndPoints.ItemUrls.RANCH_AREA}`, config)
        .then(response => response.data),

};
